import $http from '@/libs/axios'

export default class FbPosterApi {
  static async deletePostFromFacebook(pageId: number, postId: string) {
    return (await $http.delete(`poster/posts/${pageId}/fb/${postId}`)).data
  }

  static async deletePostFromDB(pageId: number, postId: string) {
    return (await $http.delete(`poster/posts/${pageId}/db/${postId}`)).data
  }

  static async postNow(pageId: number, postId: string) {
    return (await $http.get(`poster/posts/${pageId}/post-now/${postId}`)).data
  }

  static async addPost(data: any, id?: number) {
    let url = 'poster/process'
    if (id) url += `/${id}`
    return (await $http.post(url, data)).data
  }

  static async fetchPost(pageId: number, postId: string) {
    return (await $http.get(`poster/posts/${pageId}/fetch/${postId}`)).data
  }
}
